import axios from "axios";

export interface ScheduledClip {
  _id: string;
  camera_id: string;
  camera_name: string;
  filename: string;
  duration_seconds: number;
  status: 'scheduled' | 'recording' | 'completed' | 'failed' | 'cancelled';
  file_path: string;
  clip_index: number;
  scheduled_date: string;
  created_at: string;
  updated_at: string;
}

export interface ClipStats {
  total_clips: number;
  clips_sample: ScheduledClip[];
  status_breakdown: Array<{ _id: string; count: number }>;
  date_breakdown: Array<{ _id: string; count: number }>;
}

export class ScheduledRecordingService {
  private static rootUrl = '/api/scheduled-recordings';
  private static client = axios;

  static async getAllClips(): Promise<ClipStats> {
    try {
      const response = await this.client.get<{ data: ClipStats }>(`${this.rootUrl}/all-clips`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to load scheduled recordings:', error);
      throw error;
    }
  }

  static async deleteScheduledDay(cameraId: string, date: string): Promise<any> {
    try {
      const response = await this.client.delete(`${this.rootUrl}/${cameraId}/${date}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to delete scheduled day for camera ${cameraId} on ${date}:`, error);
      throw error;
    }
  }

  static async getStats(): Promise<any> {
    try {
      const response = await this.client.get(`${this.rootUrl}/stats`);
      return response.data;
    } catch (error) {
      console.error('Failed to load scheduled recording stats:', error);
      throw error;
    }
  }

  static async createScheduledRecording(data: {
    camera_id: string;
    camera_name: string;
    account_id: string;
    rtsp_url: string;
  }): Promise<any> {
    try {
      const response = await this.client.post(this.rootUrl, data);
      return response.data;
    } catch (error) {
      console.error('Failed to create scheduled recording:', error);
      throw error;
    }
  }
} 